import { SvgIcon } from '@bob/library'
import Heading from '@websrc/App/Components/Heading/Heading'
import { SpotCampaignProps } from '@websrc/Spot/Campaign/SpotCampaign'
import { LearnMoreButtonType } from '@websrc/Spot/Collapse/SpotCollapse'
import React from 'react'

import * as SC from './SpotCampaignContent.style'

export interface SpotCampaignContentProps {
  hasVideo: boolean
  hasBackgroundImage: boolean
  isReverse: boolean
  bgColor: string
  fontColor: string
  spot: SpotCampaignProps['spot']
  LearnMoreButton?: LearnMoreButtonType
  imageLazy?: boolean
  mobile?: boolean
  isTopOfPage?: boolean
}

export const SpotCampaignContent: React.FC<SpotCampaignContentProps> = ({
  mobile,
  spot,
  bgColor,
  hasBackgroundImage,
  LearnMoreButton,
  hasVideo,
  isTopOfPage,
}) => {
  const { link, cta_type } = spot

  return (
    <SC.Content
      backgroundColor={bgColor}
      data-testid={`spot-campaign-content-bg-${bgColor}`}
      hasBackgroundImage={hasBackgroundImage}
      hasVideo={hasVideo}
      mobile={mobile}
    >
      <Heading
        description={spot.description}
        headline={spot.headline}
        level={isTopOfPage ? 1 : 2}
        size={'xl'}
      />
      {link.cta_text && (
        <SC.StyledAnchor
          allowEmptyLink={true}
          ctaType={cta_type}
          link={link}
          linkSection={[spot.headline]}
        >
          {cta_type === 'tertiary' && <SvgIcon name={'ARROW_RIGHT'} size={16} />}
          <span>{link.cta_text}</span>
        </SC.StyledAnchor>
      )}
      {LearnMoreButton && (
        <SC.LearnMoreButtonWrapper isSibling={Boolean(link)}>
          <LearnMoreButton />
        </SC.LearnMoreButtonWrapper>
      )}
    </SC.Content>
  )
}
